export const views = {
  SCHOOLS: "schools",
  STATES: "states",
  STATE_SCHOOLS: "schools",
  STATE_DISTRICTS: "districts",
  S4S_GRANTEES: "solar-for-schools-grant-program",
  MEA_GRANTEES: "grants",
};

export const stateCodes = {
  PA: "PA",
  VA: "VA",
  MD: "MD",
};

export const stateCodeToName = {
  [stateCodes.PA]: "Pennsylvania",
  [stateCodes.VA]: "Virginia",
  [stateCodes.MD]: "Maryland",
};

export const viewToRoute = {
  [views.SCHOOLS]: "schools",
  [views.STATES]: "states",
  [views.STATE_SCHOOLS]: "schools",
  [views.STATE_DISTRICTS]: "districts",
  [views.S4S_GRANTEES]: "solar-for-schools-grant-program",
  [views.MEA_GRANTEES]: "grants",
};

export const mapModes = {
  STATE: "state",
};

export const statesViews = {
  CAPACITY: "capacity",
  PERCENT_SCHOOLS: "percent-schools",
};

// Shared stacking order for floating map chrome (filter panels, legends,
// buttons, etc). Higher layers render above lower ones across all map types.
export const zIndex = {
  overlay: 1, // decorative overlays: scroll fade gradients, map attribution
  mapControl: 2, // floating action buttons: filters button, zoom/reset controls
  legendToggle: 3, // legend, view-switch toggles
  panel: 4, // slide-in panels: filters panel, district detail panel
};
